mutation PublishWorkOrderDates(
  $startsAt: ISO8601DateTime!
  $customers: [String!]
  $dueDateFrom: ISO8601DateTime
  $dueDateTo: ISO8601DateTime
  $codes: [String!]
  $statuses: [String!]
) {
  publishWorkOrderDates(
    startsAt: $startsAt
    customers: $customers
    dueDateFrom: $dueDateFrom
    dueDateTo: $dueDateTo
    codes: $codes
    statuses: $statuses
  ) {
    publishedWorkOrderDates {
      success
      errors
    }
  }
}

query PublishWorkOrderDatesDryRun(
  $startsAt: ISO8601DateTime!
  $customers: [String!]
  $dueDateFrom: ISO8601DateTime
  $dueDateTo: ISO8601DateTime
  $codes: [String!]
  $statuses: [String!]
) {
  publishWorkOrderDatesDryRun(
    startsAt: $startsAt
    customers: $customers
    dueDateFrom: $dueDateFrom
    dueDateTo: $dueDateTo
    codes: $codes
    statuses: $statuses
  ) {
    count
    workOrdersOnInactiveLines
  }
}
